import React, { Fragment, useState } from "react";
import { checkProductPackageRx } from "@/lib/lens/package";
import { addToCartClickEvent } from "@/src/models/emailData";
import criteoAd from "@/src/components/LoadAnalysis/analysis/criteo";
import { gaCommonEvent } from "@/src/utils/gtagEvents";
import {
    FmButton,
    FmDrawer as FmUIDrawer,
    FmDialog,
    FmToast,
} from "@/ui-component";
import {
    useProductDetailsContext,
    useProductPackageContext,
} from "@/src/provider";
import { lensObj } from "@/store";
import Rx from "../Rx";
import { useTranslation } from "@/src/i18n/client";

interface IProps {
    isShowPackBtn: boolean;
    showErrorTip: () => void;
}

interface State {
    rxVisible: boolean;
    isShowCheckModal: boolean;
}
const PackageEsSelectBtn: React.FC<IProps> = (props) => {
    // selectBtn: any;
    const [productDetail, activeObj, packageId] = useProductDetailsContext(
        (state) => [state.productDetail, state.activeObj, state.packageId],
    );
    const [packData] = useProductPackageContext((state) => [state.packData]);
    const [isDecentered] = lensObj.useInstationStore((state) => [
        state.isDecentered,
    ]);

    const { t } = useTranslation(["productDetail", "common", "lens"]);
    const { isShowPackBtn } = props;

    const [rxVisible, setRxVisible] = useState(false);
    const [isShowCheckModal, setIsShowCheckModal] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [toastVisible, setToastVisible] = useState(false);
    const [dialogChildren, setDialogChildren] = useState("");
    const [dialogTitle, setDialogTitle] = useState("");
    const [renderBottom, setRenderBottom] = useState<(() => void) | null>(null);
    const showToastOrNot = (toastVisble: boolean = true) => {
        setToastVisible(toastVisble);
    };
    const toggerRxModal = () => {
        setRxVisible((prev) => !prev);
    };
    const toggerCheckModal = () => {
        setIsShowCheckModal((prev) => !prev);
    };

    const checkAdd = (rx: any, rxStr: string) => {
        setRxVisible(false);

        //渐进套餐必须输入add
        if (packData.packageCategoryId == 4 && !rx.add) {
            setDialogTitle(t("common:Reminder"));
            setDialogChildren(`${t("lens:PLS_SELECT_THE")} ${t("lens:ADD")}`);
            setDialogOpen(true);
            setRenderBottom(() => {
                setRxVisible(true);
            });
            return;
        }

        gaCommonEvent("pg-submit", {
            event_category: "package",
            event_label: packData.displayName,
        });

        showToastOrNot();
        checkProductPackageRx({
            rx,
            rxStr,
            packageInfo: packData,
            productInfo: productDetail,
            color_id: activeObj.id,
            page_id: packageId,
            isDecentered,
        }).then(
            () => {
                showToastOrNot(false);
                addToCartClickEvent({
                    colorId: activeObj.id,
                    price: activeObj.onsale?.price,
                });
                criteoAd.addToCart({
                    id: activeObj.id,
                    price: activeObj.onsale?.price,
                    quantity: 1,
                });
                location.href = "/pc/basket";
            },
            () => {
                showToastOrNot(false);
                setDialogOpen(true);
                setDialogChildren(
                    t("productDetail:PackageInfo.PrescriptionERROR"),
                );
                setRenderBottom(null);
            },
        );
    };
    const { p_under_market } = productDetail;
    const { colorUnderMarket, outOfStore } = activeObj;
    let addToCartOutOf = p_under_market || colorUnderMarket || outOfStore;
    return (
        <Fragment>
            <FmToast visible={toastVisible} type={"loading"}></FmToast>
            <FmDialog
                dialogTitle={dialogTitle}
                open={dialogOpen}
                bottom={
                    renderBottom
                        ? null
                        : {
                              ok: t("productDetail:PackageInfo.ChooseOthers"),
                              onOk: () => {
                                  gaCommonEvent("pg-choose other", {
                                      event_category: "package",
                                      event_label: packData.displayName,
                                  });
                              },
                              cancel: t(
                                  "productDetail:PackageInfo.CustomizeLenses",
                              ),
                              onCancel: () => {
                                  gaCommonEvent("pg-customize", {
                                      event_category: "package",
                                      event_label: packData.displayName,
                                  });
                                  location.href = `/pc/lens?lensColor=${activeObj.id}&is_package=${packageId}&usage=-1&products_id=${productDetail.products_id}`;
                              },
                          }
                }
                renderBottom={
                    renderBottom ? (
                        <FmButton onClick={() => renderBottom}></FmButton>
                    ) : null
                }
            >
                {dialogChildren}
            </FmDialog>
            <FmButton
                style={{
                    width: "4rem",
                    height: "0.72rem",
                    fontSize: "0.36rem",
                }}
                disabled={addToCartOutOf}
                onClick={() => {
                    if (isShowPackBtn && !packData.packageCategoryId) {
                        props.showErrorTip();
                        return;
                    }
                    gaCommonEvent("pg-add to cart", {
                        event_category: "package",
                        event_label: packData.displayName,
                    });
                    toggerRxModal();
                }}
            >
                {addToCartOutOf
                    ? t("productDetail:SOLD_OUT")
                    : "Añadir a la cesta"}
            </FmButton>
            {/* 处方填写 */}
            <FmUIDrawer closeable open={rxVisible} onClose={toggerRxModal}>
                <div
                    style={{
                        textAlign: "left",
                        color: "#333",
                        paddingTop: "0.6rem",
                    }}
                >
                    <Rx
                        productInfo={productDetail}
                        nextStep={checkAdd}
                        isHideImgRx={true}
                    />
                </div>
            </FmUIDrawer>
        </Fragment>
    );
};

export default PackageEsSelectBtn;
